module.exports = __webpack_public_path__ + "media/images/regions/Maradi-ed641591aaef809c6e77f102414f0315.png";